var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUnapprovedTag(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.17,
    height: 18.462,
    viewBox: "0 0 17.17 21.462",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "reject",
    transform: "translate(-33.67 -24.036)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ef2f31",
    id: "Path_2109",
    d: "M45.536 24.036h-9.049a2.82 2.82 0 0 0-2.817 2.817v15.828a2.82 2.82 0 0 0 2.817 2.819h11.536a2.82 2.82 0 0 0 2.817-2.817V29.964zm.371 2.428l2.761 3.085h-2.761zm2.116 17.692H36.487a1.476 1.476 0 0 1-1.475-1.475V26.853a1.476 1.476 0 0 1 1.475-1.475h8.077v5.513H49.5v11.79a1.476 1.476 0 0 1-1.477 1.475z",
    className: "cls-1",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ef2f31",
    id: "Path_2110",
    d: "M62.1 66.146l-2.148 2.144-2.144-2.144-1.268 1.268 2.144 2.144L56.54 71.7l1.269 1.268 2.144-2.144L62.1 72.97l1.264-1.27-2.144-2.144 2.144-2.144z",
    className: "cls-1",
    transform: "translate(-17.753 -32.689)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnapprovedTag);
export default __webpack_public_path__ + "static/media/UnapprovedTag.6a5205fd8601ab5d88c39e53ddc70d1a.svg";
export { ForwardRef as ReactComponent };